import { isAndroid as $c87311424ea30a05$export$a11b0059900ceec8 } from "./platform.js";
function $6a7db85432448f7f$export$60278871457622de(event) {
  if (event.mozInputSource === 0 && event.isTrusted) return true;
  if ($c87311424ea30a05$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
  return event.detail === 0 && !event.pointerType;
}
export {
  $6a7db85432448f7f$export$60278871457622de as isVirtualClick
};
